var EPK = EPK || {};

EPK.PharmacyDetail = EPK.PharmacyDetail || {};

EPK.PharmacyDetail.hostname = window.location.hostname;
EPK.PharmacyDetail.ReviewUrl = EPK.PharmacyDetail.hostname + window.location.pathname;
EPK.PharmacyDetail.$photoSwiper = null;

EPK.PharmacyBookmark = EPK.PharmacyBookmark || {};
EPK.PharmacyBookmark.enable = true;
EPK.PharmacyBookmark.onImage = EPK.PharmacyDetail.favoriteOnImage;
EPK.PharmacyBookmark.offImage = EPK.PharmacyDetail.favoriteOffImage;
EPK.PharmacyBookmark.syncResults = true;

EPK.Fdoc = EPK.Fdoc || {};
EPK.Fdoc.Map = EPK.Fdoc.Map || {};

EPK.PharmacyDetail.HelpfulNumberCountUp = function (objBtn) {

	var review_id = $(objBtn).attr('target-review_id');
	// CSRF対策用の CSRFトークンの値を取得
	var csrf =$(objBtn).attr('review_csrf_token');
	var controller_name =$(objBtn).attr('controller_name');
	$.ajax({
		type: 'GET',
		url: '//' + EPK.PharmacyDetail.hostname + '/reviews/helpful_number_countup',
		data: {
			review_id: review_id,
			review_csrf_token: csrf,
			controller_name: controller_name
		}
	}).done(
		function(data) {
			if (data != 'false') {
				$(objBtn).parent('li.review-nice').hide().addClass('off').show();
				//$(objBtn).parent('li.review-nice').next('li.review-count').html(data).hide().fadeIn(500);
				$('#helpful_number_' + review_id).html(data).hide().fadeIn(500);
			}

		}
	).fail(
		function(data) {

		}
	);

};

EPK.PharmacyDetail.showBookmarkLogin = function () {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: '#modal-bookmark-require-login'},
		type: 'inline',
		modal: true
	}, 0);
};

EPK.PharmacyDetail.saveBookmark = function () {
	var $form = $("#form-Bookmark");
	$.ajax({
		url: $form.attr('action'),
		type: 'POST',
		data: {"op": "add"},
		cache: false,
		dataType : "json"
	}).done(function(data, textStatus, jqXHR){

		//console.log(data);

		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#modal-bookmark-complete'},
			type: 'inline',
			modal: true
		}, 0);
		$("#btn-addBookmark").hide();
		$("#btn-deleteBookmarkConfirm").show();

	}).fail( function(data) {
		//console.log("shop like fail");
		$.magnificPopup.open({
			items: {src: "#modal-bookmark-submit-fail"},
			type: 'inline',
			modal: true
		}, 0);
	});
};

EPK.PharmacyDetail.showConfirmDeleteBookmark = function () {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: '#modal-bookmark-delete-confirm'},
		type: 'inline',
		modal: true
	}, 0);
};

EPK.PharmacyDetail.deleteBookmark = function () {
	var $form = $("#form-Bookmark");
	$.ajax({
		url: $form.attr('action'),
		type: 'POST',
		data: {"op": "delete"},
		cache: false,
		dataType : "json"
	}).done(function(data, textStatus, jqXHR){
		//console.log(data);

		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#modal-bookmark-delete-complete'},
			type: 'inline',
			modal: true
		}, 0);
		$("#btn-addBookmark").show();
		$("#btn-deleteBookmarkConfirm").hide();

	}).fail( function(data) {
		//console.log("shop like fail");
	});
};

EPK.PharmacyDetail.postShopLike = function () {
	if (!EPK.common.isLogin) {
		$.magnificPopup.open({items: {src: '#modal-net_request_login', type: 'inline'}});
		return;
	}

	// CSRF対策用の CSRFトークンの値を取得
    var csrf = $('input[name=shop_like_csrf_token]').val();

    // controller名取得
    var controller_name = $('input[name=controller_name]').val();

	var $form = $("#form-ShopLike");
	var data = {
		'member_id': EPK.common.member_id,
		'shop_id': EPK.PharmacyDetail.shop_id,
		'shop_like_csrf_token': csrf,
		'controller_name': controller_name
	};

	$.ajax({
		url: $form.attr('action'),
		type: 'POST',
		cache: false,
		dataType : "json",
		data: data
	}).done(function(data, textStatus, jqXHR){
		if (data['result']=="success"){
			//リクエスト完了モーダルの表示
			EPK.PharmacyDetail.showRequestCompletePopup();

			$("#net_requests_counts_area").show();

			//リクエスト件数のインクリメント
			var original = $("#net_requests_counts_text").text();
			$("#net_requests_counts_text").text(parseInt(original)+1);

			//リクエストボタンのテキストの上書き
			$('#btn-submitShopLine').text('ネット受付リクエスト済み');

			//リクエストボタンを押せなくする
			$('#btn-submitShopLine').hide().addClass('stop-link').show();

			//お気に入り済み状態にする
			$("#btn-addBookmark").hide();
			$("#btn-deleteBookmarkConfirm").show();
			EPK.PharmacyBookmark.changeBtn(EPK.PharmacyBookmark.$btns["addBtn"], "on");

		}else if (data['result']=="error") {
			EPK.PharmacyDetail.showRequestErrorPopup();

		}else if(data['result']=="ng_add_bookmark") {
			console.log("shop like fail");// 他と合わせる
		}

	}).fail( function(data) {
		EPK.PharmacyDetail.showRequestErrorPopup();
	});
};

EPK.PharmacyDetail.showRequestCompletePopup = function () {
	$.magnificPopup.open({
		items: {
			src: '#modal-net_request_complete',
			type: 'inline',
		},
		showCloseBtn: false
	});

	// 「リクエストが完了しました」ポップアップ
	$(".request-complete-modal").show();
	$('.request-complete-modal a').click(
		function(e){
			$(".request-complete-modal").hide();
		}
	);

	// アンケート回答チェック
	//入力欄の操作時
	$('.question-num input[type="radio"]').change(function () {
		var flag = false;
		var valNum = 0;
		//必須項目をひとつずつチェック
		$('.question-num').each(function(e) {
			if($('.question-num').eq(e).find('input[type="radio"]:checked').length === 1 ) {
				valNum += 1;
			}
		});
		if($('.question-num').length === valNum) {
			flag = true;
		}

		// ボタン状態変更
		if (flag) {
			//$('.submit-button button').prop("disabled", false);
			$('.request_enquete_submit a').removeClass('is-disabled');
		} else {
			//$('.submit-button button').prop("disabled", true);
			$('.request_enquete_submit a').addClass('is-disabled');
		}
	});

	$("#popup_shop_list").swiper({
		slidesPerView: 3,
		centeredSlides: false,
		grabCursor: true,
		loop: true,
		spaceBetween: 10,
		preloadImages: true,
		paginationClickable: true,
		nextButton: "#modal-net_request_complete .swiper-button-next",
		prevButton: "#modal-net_request_complete .swiper-button-prev"
	});
};

EPK.PharmacyDetail.showRequestErrorPopup = function () {
	$.magnificPopup.open({items: {src: '#modal-net_request_error', type: 'inline'}});
	$('#error_retry').on('click', function(){
		EPK.PharmacyDetail.postShopLike();
	});
};

EPK.PharmacyDetail.Map = function(){
	var canvas = document.getElementById('map-canvas');

	var icon = canvas.getAttribute('target-icon');
	var lat = canvas.getAttribute('target-lat');
	var lng = canvas.getAttribute('target-lng');
	var latlng = new google.maps.LatLng(lat, lng);
	var mapOptions = {
		zoom: 18,
		center: latlng,
		gestureHandling: 'greedy',
		mapId:"DEMO_MAP_ID"
	};
	var map = new google.maps.Map(canvas, mapOptions);
	var markers = [];
	markers[0] = new google.maps.marker.AdvancedMarkerElement({
		map: map,
		position: latlng,
	});
	markers[0].content.className = "animation-down";
};

EPK.PharmacyDetail.MapPcUnderLayer = function(){
	var canvas = document.getElementById('map-canvas');

	var icon = canvas.getAttribute('target-icon');
	var lat = canvas.getAttribute('target-lat');
	var lng = canvas.getAttribute('target-lng');
	var latlng = new google.maps.LatLng(lat, lng);
	var mapOptions = {
		zoom: 16,
		center: latlng,
		gestureHandling: 'greedy',
		mapId:"DEMO_MAP_ID"
	};
	var map = new google.maps.Map(canvas, mapOptions);
	var markers = [];
	var pinEl = document.createElement("img");
	pinEl.src = icon;
	//画像自体のサイズを指定
	pinEl.style.width = "21px";
	pinEl.style.height = "30px";
	pinEl.className = "animation-down";
	markers[0] = new google.maps.marker.AdvancedMarkerElement({
		map: map,
		position: latlng,
		content: pinEl,
	});
};


EPK.PharmacyDetail.initTopPicture = function(){
	var $galleryTop = $('#photo-main-container').swiper({
		spaceBetween: 10,
		slidesPerView: 1,
		effect: "fade",
		lazyLoading: true
	});
	var $gallerySubs = $('#photo-sub-container').swiper({
		slideWidth: 40,
		spaceBetween: 4,
		centeredSlides: false,
		slidesPerView: 12,
		touchRatio: 0.2,
		nextButton: '.thumbnail-button-next',
		prevButton: '.thumbnail-button-prev',
		onTap: function(swiper, event){
			var index = swiper.clickedIndex;
			$galleryTop.slideTo(index);
			//console.log("clicked");
		},
	});
};

EPK.PharmacyDetail.initPhotoPage = function(){
	var $zoomBtn = $(".picture-zoom-image");
	var $zoomPics = $("#shop-large-pictures");
	var $pageNumber = $("#page_number");
	var zoomSwiper;

	$zoomBtn.magnificPopup({
		"type": 'inline',
		"preloader": false,
		'showCloseBtn': false,
		'removalDelay': 0,
		'mainClass': 'mfp-fade',
		'overflowY': 'hidden',
		callbacks:{
			// MagnificPopup が要素を再生成するので、都度swiperを初期化
			open: function(){
				if(!EPK.PharmacyDetail.$photoSwiper){
					EPK.PharmacyDetail.$photoSwiper = $zoomPics.swiper({
						// scrollbar: '.swiper-scrollbar',
						scrollbarHide: true,
						slidesPerView: 1,
						centeredSlides: true,
						spaceBetween: 10,
						grabCursor: true,
						preloadImages: true,
						nextButton: "#shop-large-pictures .swiper-button-next",
						prevButton: "#shop-large-pictures .swiper-button-prev",
						onSlideChangeEnd: function(_swiper){
							$pageNumber.text((_swiper.activeIndex)*1 + 1);
						}
					});
				}
			}
		}
	});
	$zoomBtn.on('click', function(){
		var pageNum = $(this).attr('data-pagenum')*1;
		EPK.PharmacyDetail.$photoSwiper.slideTo(pageNum, 0);
		$pageNumber.text(pageNum + 1);
	});
};

EPK.PharmacyDetail.AcceptCoupon = function (url, coupon_name, reserve_flg, pharmacy_id, detail_action, coupon_csrf_token, controller_name) {

	$.ajax({
		url: url,
		type: 'POST',
		data: {"coupon_csrf_token": coupon_csrf_token, "controller_name": controller_name},
		cache: false,
		dataType : "json"
	}).done(function(data, textStatus, jqXHR){
		var src = '';
		var selector = '';
		var need_epark_point = 0;
		var user_epark_point = 0;
		if (data.result.need_epark_point > 0) {
			need_epark_point = EPK.PharmacyDetail.numSeparate(data.result.need_epark_point);
			user_epark_point = EPK.PharmacyDetail.numSeparate(data.result.user_epark_point);
		}
		//console.log(data);

		if (reserve_flg) {
			if (data.result.status == 2) {
				src = '#coupon-registeredandbook';
				selector = '#popup-reserved-coupon-name';
			} else {
				if (data.result.need_epark_point > 0) {
					src = '#epark-point-coupon-reserve';
					selector = '#popup-reserve-epark-point-coupon-name';

					$('#need_epark_point-epark-point-coupon-reserve').html(need_epark_point);
					$('#need_epark_point-epark-point-coupon-reserve2').html(need_epark_point);
					$('#user_epark_point-epark-point-coupon-reserve').html(user_epark_point);
				} else {
					src = '#coupon-registandbook';
					selector = '#popup-reserve-coupon-name';
				}
			}
		} else {
			if (data.result.need_epark_point > 0) {
				src = '#epark-point-coupon-regist';
				selector = '#popup-epark-point-coupon-name';

				$('#need_epark_point-epark-point-coupon-regist').html(need_epark_point);
				$('#need_epark_point-epark-point-coupon-regist2').html(need_epark_point);
				$('#user_epark_point-epark-point-coupon-regist').html(user_epark_point);
			}else{
					src = '#coupon-regist';
					selector = '#popup-coupon-name';
			}
		}

		// 完了モーダルの表示
		$.magnificPopup.close();
		if(data.result.status == 1 || data.result.status == 2 && reserve_flg){
			if (data.result.status == 1) {
				$.magnificPopup.open({
					items: { src: src },
					type: 'inline',
					callbacks: {
						close: function () {
							location.reload();
						}
					},
					modal: true
				}, 0);
			} else {
				$.magnificPopup.open({
					items: { src: src },
					type: 'inline',
					modal: true
				}, 0);
			}
			$(selector).html(coupon_name);
		} else {
			$.magnificPopup.open({
				items: {src: '#coupon-regist-error'},
				type: 'inline',
				modal: true
			}, 0);
			if(data.result.error != ""){
				$('#coupon-regist-error p.coupon-error-text').html(data.result.error);
				$('#reregist').hide();
			}
			$('#coupon-regist-error .w-btn').on('click', function(event){
				$.magnificPopup.close();
				EPK.PharmacyDetail.AcceptCoupon(url, coupon_name, reserve_flg, pharmacy_id, detail_action);
			});
		}
	}).fail( function(data) {
		// console.log("cancel fail");
		$.magnificPopup.close();
		$.magnificPopup.open({
			items: {src: '#coupon-regist-error'},
			type: 'inline',
			modal: true
		}, 0);

		$('#coupon-regist-error .w-btn').on('click', function (event) {
			$.magnificPopup.close();
			EPK.PharmacyDetail.AcceptCoupon(url, coupon_name, reserve_flg, pharmacy_id, detail_action);
		});

	});
}

/**
 * EPARKポイント交換クーポン取得時の確認
 */
EPK.PharmacyDetail.OpenConfirmPopupEparkPointCoupon = function (coupon_name, reserve_flg, pharmacy_id, coupon_id, detail_action, coupon_csrf_token, controller_name) {

	// ログイン時のみ実施
	if (!EPK.common.isLogin) {
		return true;
	}

	var paramData = {
		'shop_id': pharmacy_id,
		'coupon_id': coupon_id,
		'coupon_csrf_token': coupon_csrf_token,
		'controller_name': controller_name
	};

	$.ajax({
		type: 'POST',
		url: '/api/detail/get_and_check_epark_point_coupon_data',
		data: paramData,
		cache: false,
		dataType: 'json',
		timeout: 100000
	})
		.done(function (data) {
			//console.log(data);

			if (data['result'] == 'success') {
				var user_epark_point = EPK.PharmacyDetail.numSeparate(data['total_pt']);
				var after_epark_point = EPK.PharmacyDetail.numSeparate(data['after_epark_point']);
				var need_epark_point = '-' + EPK.PharmacyDetail.numSeparate(data['need_epark_point']);

				$('#coupon-name-confirm-coupon-epark-point').html(coupon_name);
				$('#user-epark-point-confirm-coupon-epark-point').html(user_epark_point);
				$('#need-epark-point-confirm-coupon-epark-point').html(need_epark_point);
				$('#after-epark-point-confirm-coupon-epark-point').html(after_epark_point);

				var $target = $('#accept-epark-point-coupon a');
				$target.data('coupon_id', coupon_id);
				$target.data('pharmacy_id', pharmacy_id);
				$target.data('coupon_name', coupon_name);
				$target.data('reserve_flg', reserve_flg);
				$target.data('detail_action', detail_action);

				$.magnificPopup.open({
					items: {
						src: '#confirm-coupon-epark-point',
						type: 'inline'
					}
				});

				return false;

			} else if (data['result'] == 'not_login') {
				$.magnificPopup.open({
					items: {
						src: '#coupon-login-popup',
						type: 'inline'
					}
				});

				return false;

			} else if (data['result'] == 'api_error') {
				$.magnificPopup.open({
					items: {
						src: '#epark-point-api-error',
						type: 'inline'
					}
				});

				console.log('api_error shop_id:' + pharmacy_id + ' coupon_id:' + coupon_id);
				return false;

			} else if (data['result'] == 'already_get_both_reserve') {
				if (reserve_flg) {
					$.magnificPopup.open({
						items: {
							src: '#coupon-registeredandbook',
							type: 'inline'
						}
					});

					$('#popup-reserved-coupon-name').html(coupon_name);
				} else {
					$('#error-message-epark-point-api-error').html(data['error_message']);

					$.magnificPopup.open({
						items: {
							src: '#epark-point-api-error',
							type: 'inline'
						}
					});
				}

				return false;

			} else if (data['result'] == 'in_short_epark_point') {
				var user_epark_point = EPK.PharmacyDetail.numSeparate(data['total_pt']);
				var need_epark_point = '-' + EPK.PharmacyDetail.numSeparate(data['need_epark_point']);
				var after_epark_point = EPK.PharmacyDetail.numSeparate(data['after_epark_point']);

				$('#popup-user-epark-point2').html(user_epark_point);
				$('#need-epark-point').html(need_epark_point);
				$('#popup-short-epark-point').html(after_epark_point);

				if (Number(user_epark_point) == 0) {
					$('.area-short-epark-point').remove();
				}

				$.magnificPopup.open({
					items: {
						src: '#in-short-epark-point',
						type: 'inline'
					}
				});

				return false;

			} else if (data['result'] == 'invalid_error') {
				$('#error-message-epark-point-api-error').html(data['error_message']);

				$.magnificPopup.open({
					items: {
						src: '#epark-point-api-error',
						type: 'inline'
					}
				});

				console.log('invalid_error shop_id:' + pharmacy_id + ' coupon_id:' + coupon_id);
				return false;
			}

			return true;
		}).fail(function (data) {
			console.log('failed');
			console.log(data);
			return false;
		});
};

EPK.PharmacyDetail.execMobileEmailDetailInformation = function(index){
	if(!EPK.PharmacyDetail.checkMobileEmailDetailInformation(index)){
		return false;
	}

	EPK.PharmacyDetail.sendMobileEmailDetailInformation(index);

	return true;
}

EPK.PharmacyDetail.checkMobileEmailDetailInformation = function(index){
	var mobileEmail = $("#mobile_email_" + index).val();
	mobileEmail = mobileEmail.trim();

	//メールアドレスの入力チェック
	if(mobileEmail == ''){
		alert('メールアドレスを入力してください。');
		return false;
	}

	if(!mobileEmail.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)){
		alert('メールアドレスの形式で入力してください。');
		return false;
	}

	return true;
}

EPK.PharmacyDetail.sendMobileEmailDetailInformation = function(index){
	var mobileEmail = $("#mobile_email_" + index).val();
	mobileEmail = mobileEmail.trim();

	var kmBrandPageIdEmailSend = $("#km_brand_page_id_email_send").val();

	var $form = $("#form-MobileEmailSend");

	// CSRF対策用の CSRFトークンの値を取得
	var csrf = $('input[name=csrf_token]').val();

	// controller名取得
    var controller_name = $('input[name=c_name]').val();

	data = {
		'shop_id': EPK.PharmacyDetail.shop_id,
		'km_brand_page_id_email_send': kmBrandPageIdEmailSend,
		'mobile_email': mobileEmail,
		'csrf_token': csrf,
		'controller_name': controller_name
	}
	//console.log(data);

	$.ajax({
		url: $form.attr('action'),
		type: 'POST',
		cache: false,
		dataType : "json",
		data: data
	}).done(function(data, textStatus, jqXHR){
		//console.log(data);
		//console.log("send mail success");
		if (data['result']=="success"){
			$.magnificPopup.close();

			$("#mobile_email_send_complete").text(mobileEmail + 'にメールを送信しました。');

			$.magnificPopup.open({
				items: {src: '#modal-mobile_email_detail_information_send_complete'},
				type: 'inline',
				modal: true
			}, 0);
		}else if (data['result']=="error") {
			//console.log("send mail error");
			//console.log(data);
			$.magnificPopup.close();
			$("#mobile_email_index").val(index);
			$.magnificPopup.open({
				items: {src: '#modal-send-url-mobile_retry'},
				type: 'inline',
				modal: true
			}, 0);
		}
	}).fail( function(data) {
		//console.log("send mail fail");
		//console.log(data);
		$("#modal-send-url-mobile").hide();
		$("#modal-send-url-mobile_retry").show();
	});
};

EPK.PharmacyDetail.bindFloatingShopHide = function(){
	var html = window.document.documentElement;
	if($('#common_footer').length == 0) return;
	var off = $('#common_footer').offset();
	var positionFooter = off.top;
	var $floatingNav = $("#floating-navbar-bottom");
	var $goToTop = $("#go-to-top");
	var $goToTop = $("#go-to-top");
	var showFlgTop = true;
	var showFlgNav = true;

	if(($(window).scrollTop() + html.clientHeight) > positionFooter || $(window).scrollTop() < 100) {
		$floatingNav.hide();
		$goToTop.stop().animate({'bottom' : '-100px'}, 200);
		showFlgTop = false;
		showFlgNav = false;
	}

	$(window).bind("scroll", function() {
		var currentTop = $(this).scrollTop();
		var currentBottom = $(this).scrollTop()  + html.clientHeight;
		if(currentBottom > positionFooter){
			if(showFlgNav){
				$floatingNav.fadeOut(100);
				showFlgNav = false;
			}
			if(showFlgTop) {
				$goToTop.stop().animate({'bottom' : '-100px'}, 200);
				showFlgTop = false;
			}
		}else if(currentTop < 100){
			if(showFlgNav){
				$floatingNav.fadeOut(100);
				showFlgNav = false;
			}
			if(showFlgTop) {
				$goToTop.stop().animate({'bottom' : '-100px'}, 200);
				showFlgTop = false;
			}
		}else{
			if(!showFlgNav){
				$floatingNav.fadeIn(100);
				showFlgNav = true;
			}
			if(!showFlgTop) {
				$goToTop.stop().animate({'bottom' : '90px'}, 200);
				showFlgTop = true;
			}
		}
	});
};

/**
 * 近くの病院・診療所（EPARK病院情報）地図表示
 */
EPK.Fdoc.Map.init = function() {
	// マーカーのサイズ
	if(EPK.Fdoc.isMobile) {
		//var arg = {
		//		marker_here: {w: 17, h: 17},
		//		marker: {w: 21, h: 30}
		//};
	}else {
		var arg = {
				//marker_here: {w: 17, h: 17},
				marker: {w: 24, h: 31}
		};
	}
	var canvas = document.getElementById('map-canvas');
	var lat = canvas.getAttribute('data-lat');
	var lng = canvas.getAttribute('data-lng');
	var latlng = new google.maps.LatLng(lat, lng);
	var mapOptions = {
			zoom: EPK.Fdoc.Map.zoomLv,
			center: latlng,
			panControl: false,
			zoomControl: false,
			scaleControl: false,
			streetViewControl: false,
			mapTypeControl: false,
			gestureHandling: 'greedy',
			mapId:"DEMO_MAP_ID"
	};
	var map = new google.maps.Map(canvas, mapOptions);

	if(map){
		var markers = EPK.Fdoc.Map.markers;
		var markerSize = [];
		var zIndexNum = markers.length;

		markers.forEach(function(pin, key) {
			//薬局のマーカー
			if(key == 0){
				var marker = new google.maps.marker.AdvancedMarkerElement({
					map: map,
					position: pin.latlng,
					//マーカーの重なり順 → 薬局は一番下
					zIndex: 0,
				});
				marker.content.className = "animation-down";
			}else{
				//マーカーの重なり順 → 薬局は一番下。薬局から近い病院を上に
				zIndexNum = zIndexNum - 1;
				if(zIndexNum < 0){
					zIndexNum = 0;
				}
				var pinEl = document.createElement("img");
				pinEl.src = pin.iconImg;
				pinEl.width = arg.marker.w;
				pinEl.height = arg.marker.h;
				var marker = new google.maps.marker.AdvancedMarkerElement({
					map: map,
					position: pin.latlng,
					//マーカーの重なり順 → 近い病院を上に
					zIndex: zIndexNum,
					content: pinEl
				});
				marker.content.className = "animation-down";
				// マーカーのクリックイベント設定
				marker.addListener('click', (function(anchor){
					return function(){ location.hash = anchor; };
				})(pin.anchor));
			}
		});
	}
};

/**
 * 予約関連のボタンを描画
 * @method renderRsvBtn
 */
EPK.PharmacyDetail.renderRsvBtn = function(){
	var shopId = EPK.PharmacyDetail.shop_id;
	if(!shopId) {
		// フロートボタンを表示
		var floatBtnEl = document.getElementById('detail-reserve-float-btn');
		if(floatBtnEl) {
			$(floatBtnEl).empty();
		}
		// ローディングアイコン非表示
		EPK.PharmacyDetail.hiddenRsvBtnLoadingIcon();
		EPK.PharmacyDetail.callbackOfRenderFloatBtn();
		return;
	}

	//特商法ページの場合は抜ける
	if (EPK.common.action == 'law') return;

	// APIに渡す情報を作成
	var url = '/api/detail/float_btn/s'+shopId;
	var _action = EPK.common.action;
	var page = (!_action || _action === 'index') ? '' : _action ;
	if(page === "shopToriokiItem") {
		page ='shop_torioki_item';
	} else if(page === "healthSupport") {
		page ='health_support';
	}
	var floatBtn = page === 'map' ? 0 : (page === 'coupon' ? 2 : 1);
	$.ajax({
		url: url,
		type: 'POST',
		dataType: 'HTML',
		data: {
			page: page,
			float_btn: floatBtn,
		}
	}).done(function(resultData) {
		// フロートボタンを表示
		var floatBtnEl = document.getElementById('detail-reserve-float-btn');
		if(floatBtnEl) {
			var $floatBtnEl = $(floatBtnEl);
			$floatBtnEl.empty();
			if(resultData) {
				$floatBtnEl.append(resultData);
			}
		} else if (EPK.PharmacyDetail.shohobin_flag == 0) {
			// 電話帳の場合body最下部へ追加
			$('body').append(resultData);
		}
		// 予約用のボタンを描画
		EPK.PharmacyDetail.renderReservationBtn();
		EPK.PharmacyDetail.renderParkingReservationBtn();
		EPK.PharmacyDetail.renderDeliveryReservationBtn();
		EPK.PharmacyDetail.setBookmarkBtnEvent();
	}).fail(function(){
		// フロートボタンを表示
		var floatBtnEl = document.getElementById('detail-reserve-float-btn');
		if(floatBtnEl) {
			$(floatBtnEl).empty();
		}
	}).always(function() {
		// ローディングアイコン非表示
		EPK.PharmacyDetail.hiddenRsvBtnLoadingIcon();
		// スクロールの設定
		EPK.PharmacyDetail.bindFloatingShopHide();
		// フロートボタンのあとに実行する関数
		EPK.PharmacyDetail.callbackOfRenderFloatBtn();
	});
};
/**
 * お気に入りボタンのイベントを設定
 * @method setBookmarkBtnEvent
 */
EPK.PharmacyDetail.setBookmarkBtnEvent = function() {
	// お気に入りボタンのイベント
	if(EPK.PharmacyBookmark) {
		EPK.PharmacyBookmark.resettingBookmarkBtn();
			// 詳細ヘッダーのお気に入りボタンの表示設定
		if(EPK.PharmacyDetail.bookmarkFlg) {
			EPK.PharmacyBookmark.changeBtn(EPK.PharmacyBookmark.$btns["addBtn"], "on");
		}
		if(EPK.isLogin == 1){
			$('#btn-addBookmark').on('click', function(event) {
				//console.log("onclick");
				EPK.PharmacyDetail.saveBookmark(event);
			});
			$('#btn-deleteBookmarkConfirm').on('click', function(event) {
				EPK.PharmacyDetail.showConfirmDeleteBookmark(event);
			});
/*			$('#btn-deleteBookmark').on('click', function(event) {
				EPK.PharmacyDetail.deleteBookmark(event);
			});
*/
			$('#btn-deleteBookmarkRetry').on('click', function(event) {
				EPK.PharmacyDetail.deleteBookmark(event);
			});
			$('#btn-addBookmarkRetry').on('click', function(event) {
				EPK.PharmacyDetail.saveBookmark(event);
			});

		} else {
			$('#btn-addBookmark').on('click', function (event) {
				//console.log("onclick");
				EPK.PharmacyDetail.showBookmarkLogin(event);
			});
		}
	}
};
/**
 * 予約ボタン系のイベントを設定
 * @method setRevBtnEvent
 */
EPK.PharmacyDetail.setRevBtnEvent = function () {
	// フロート、ヘッダーの宅配予約ボタンのイベント設定
	if(EPK.Delivery && EPK.Delivery.Popup) {
		EPK.Delivery.Popup.$deliveryBtn = $('.delivery-btn');
		EPK.Delivery.Popup.initEvents();
		EPK.Delivery.Popup.unsetBindEvents();
		EPK.Delivery.Popup.updateEventDeliveryElements();
		EPK.Delivery.Popup.bindEvents();
	}
	// フロート、ヘッダーの駐車場予約ボタンのイベント設定
	if(EPK.Parking && EPK.Parking.Popup) {
		$('.parking-reserve-btn').on('click', function() {
			EPK.Parking.Popup.open();
		});
	}
};

/**
 * 予約ボタン系のローディングアイコンの非表示処理
 * @method hiddenRsvBtnLoadingIcon
 */
EPK.PharmacyDetail.hiddenRsvBtnLoadingIcon = function(){
	// ローディングアイコン非表示
	var loadingEls = document.querySelectorAll('.loading-normal_rev_btn');
	[].forEach.call(loadingEls, function(el) {
		if (el) el.style.display = 'none';
	});
};

/**
 * 通常予約のボタンの描画
 * @method renderReservationBtn
 */
EPK.PharmacyDetail.renderReservationBtn = function(){
	var parentEl = null;
	var rsvBtns = [];
	var availableData = EPK.PharmacyDetail.availables;
	var nearReserveAndOpenPharmacyShops = EPK.PharmacyDetail.nearReserveAndOpenPharmacyShops;

	// 予約ボタンを表示
	parentEl = document.getElementById('shoho-rsv-btn-body');
	if(parentEl && parentEl.style.display === 'none') {
		parentEl.style.display = 'block';
	}
	if(availableData && availableData.use_shoho_flag) {
		rsvBtns = document.querySelectorAll('.possible-shoho_rsv_btn');
	} else {
		if(nearReserveAndOpenPharmacyShops) {
			rsvBtns = document.querySelectorAll('.near-shoho_rsv_btn');
		}
		if(!rsvBtns || !rsvBtns.length) {
			rsvBtns = document.querySelectorAll('.off-hour-shoho_rsv_btn');
		}
	}
	if(rsvBtns && rsvBtns.length) {
		[].forEach.call(rsvBtns, function(btnEl) {
			if(btnEl) {
				btnEl.style.display = '';
			}
		});
	}
};
/**
 * 受付に関する赤枠アラート文言の描画
 * @method renderReceptionistWarning
 */
EPK.PharmacyDetail.renderReceptionistWarning = function(){
	var warningEl = document.getElementById('common-alert-box-area');
	if(!warningEl) return;
	var alertParent = document.querySelector(EPK.PharmacyRich ? '.rich-detail-top' : '.st-detail-top' );
	if(!alertParent) {
		warningEl.parentNode.removeChild(warningEl);
		return;
	}
	alertParent.appendChild(warningEl);
	var availableObj = EPK.PharmacyDetail.availables;
	var isUseToday = availableObj && availableObj.use_shoho_flag === true && availableObj.today_receipt_flag === 1;

	if(	isUseToday ) {
		var msgEl = warningEl.querySelector('.shoho-use-today-off');
		if(msgEl) {
			msgEl.style.display = '';
			if(warningEl.style.display === 'none') {
				warningEl.style.display = '';
			}
		}
	}
};

/**
 * 駐車場予約のボタンの描画
 * @method renderParkingReservationBtn
 */
EPK.PharmacyDetail.renderParkingReservationBtn = function(){
	var isUseShoho = EPK.PharmacyDetail.availables ? EPK.PharmacyDetail.availables.use_shoho_flag === true : false;
	var isParkingRsv = EPK.PharmacyDetail.availables ? EPK.PharmacyDetail.availables.parking_receive === 1 : false;
	var query = isUseShoho && isParkingRsv ? '.possible-parking_btn' : '.off-hour-parking_btn';
	var parkingRsvBtns = document.querySelectorAll(query); // 駐車場予約のボタンエレメント
	[].forEach.call(parkingRsvBtns, function(btnEl) {
		if(btnEl) {
			btnEl.style.display = '';
		}
	});
};

/**
 * 宅配予約のボタンの描画
 * @method renderDeliveryReservationBtn
 */
EPK.PharmacyDetail.renderDeliveryReservationBtn = function(){
	var availableCount = EPK.PharmacyDetail.availables ? EPK.PharmacyDetail.availables.delivery_available_count : 0;
	var isWaiting = EPK.PharmacyDetail.availables ? EPK.PharmacyDetail.availables.permission_waiting === 1 : false;
	var isMobileStop = EPK.PharmacyDetail.availables ? EPK.PharmacyDetail.availables.mobile_status === 1 : false;
	var elQuery = '.off-hour-delivery_btn';

	if(availableCount > 0 && !isWaiting && !isMobileStop) {
		elQuery = '.possible-delivery_btn';
	}
	var deliveryBtns = document.querySelectorAll(elQuery); // 宅配予約のボタンエレメント
	[].forEach.call(deliveryBtns, function(btn) {
		if(btn) {
			btn.style.display = "";
		}
	});
};

EPK.Delivery = EPK.Delivery || {};
EPK.Delivery.Popup = EPK.Delivery.Popup || {};

EPK.Delivery.Popup.$deliveryBtn = null;
EPK.Delivery.Popup.$deliveryPopupCloseBtn = $('.deli-btn-box .close');
EPK.Delivery.Popup.$deliveryPopupNextBtn = $('.deli-btn-box .agree a');
EPK.Delivery.Popup.$ulDeliveryDaySelections = $('#ul_delivery_day_selections a');
EPK.Delivery.Popup.$btnBackToFlow = $('.back-to-flow');
EPK.Delivery.Popup.$btnBack = $('.dayselect-backbtn a');
EPK.Delivery.Popup.$selectDay = $('#select-day');
EPK.Delivery.Popup.$btnChangeDate = $('#select-day').closest('li');
EPK.Delivery.Popup.$selectTime = $('.select-time.delivery');
EPK.Delivery.Popup.$btnSendDeliveryForm = $('.modal-btn-send a');
EPK.Delivery.Popup.$perUnitTime = $('.per-unit-time');
EPK.Delivery.Popup.$reserveDatetimeSwiper = null;

EPK.Delivery.Popup.selectedDate = null;
EPK.Delivery.Popup.selectedStartTime = null;
EPK.Delivery.Popup.selectedEndTime = null;
EPK.Delivery.Popup.deliveryBaseUrl = EPK.Delivery.Popup.$btnSendDeliveryForm.data('url');
EPK.Delivery.Popup.perUnitTime = 0;

EPK.Delivery.Popup.popupIds = [
	'#modal-delivery-flow',
	'#modal-delivery-day',
	'#modal-delivery-time'
];

EPK.Delivery.Popup.open = function(index) {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: EPK.Delivery.Popup.popupIds[index]},
		type: 'inline',
		modal: true,
		callbacks: {
			close: index === 2 ? function () {
				// 時間指定のスライダーを削除
				EPK.Delivery.Popup.deleteDateTimeSlide();
			} : null
		}
	}, 0);
};

EPK.Delivery.Popup.initPopupSwiper = function () {
	if(!EPK.Delivery.Popup.$reserveDatetimeSwiper) {
		EPK.Delivery.Popup.$reserveDatetimeSwiper = $('#reserve_datetime_swiper').swiper({
			centeredSlides: true,
			initialSlide: 0,
			slidesPerView: 'auto',
			loop: false,
			nextButton: '.ts-slider-fwd',
			prevButton: '.ts-slider-rev',
		});
	}
	EPK.Delivery.Popup.$selectTime.text('');
	EPK.Delivery.Popup.perUnitTime = 0;

	var year = EPK.Delivery.Popup.selectedDate.toString().slice(0, 4);
	var month = EPK.Delivery.Popup.selectedDate.toString().slice(4, 6);
	var day = EPK.Delivery.Popup.selectedDate.toString().slice(-2);
	var dateKey = year + '-' + month + '-' + day;
	var defaultSlide = 0;
	var sliderElement = '';
	$.each(EPK.Delivery.availableDatetime['time_table'][dateKey], function (index, el) {

		var startTime = ('0' + el.start_time.toString().replace(':', '')).slice(-4);
		var endTime = ('0' + el.end_time.toString().replace(':', '')).slice(-4);
		var inputDisabled = 'disabled';
		if (el.availabled_time) {
			if (defaultSlide == 0) {
				defaultSlide = index;
			}
			inputDisabled = '';
		}
		var inputEl = '<input type="radio" name="delivery-select-date" id="t' + index + '" data-time_index="' + index + '" data-start-time="' + startTime + '" data-end-time="' + endTime + '" ' + inputDisabled + '>';
		var timeEl = el.start_time + '<span>～</span>' + el.end_time;
		var labelEl = '<label for="t' + index + '" class="GA_detail_delivery_selecttime">' + timeEl + '</label>';
		// スライダーを追加
		sliderElement += '<li class="swiper-slide" >' + inputEl + labelEl + '</li>';

		if (EPK.Delivery.Popup.perUnitTime == 0) {
			var d1 = new Date(dateKey.replace(/-/g, '/') + ' ' + startTime.slice(0, 2) + ':' + startTime.slice(2));
			var d2 = new Date(dateKey.replace(/-/g, '/') + ' ' + endTime.slice(0, 2) + ':' + endTime.slice(2));
			EPK.Delivery.Popup.perUnitTime = EPK.Delivery.Popup.minutesDistance(d1, d2);

			if (EPK.Delivery.Popup.perUnitTime < 60) {
				var text = EPK.Delivery.Popup.perUnitTime + '分';
			} else {
				var text = EPK.Delivery.Popup.perUnitTime / 60 + '時間';
			}
			EPK.Delivery.Popup.$perUnitTime.text(text);
		}
	});
	// スライダー追加、表示の初期スライド位置を設定
	EPK.Delivery.Popup.$reserveDatetimeSwiper.appendSlide(sliderElement);
	EPK.Delivery.Popup.$reserveDatetimeSwiper.slideTo(defaultSlide > 0 ? defaultSlide - 1 : defaultSlide, 0);

	$('.timeselect-slider label[for^=t]').on('click', function () {
		var inputElId = this.getAttribute('for');
		var $targetInputEl = $('#'+inputElId);
		if(!$targetInputEl.length || $targetInputEl.is(':disabled') ) {
			return;
		}
		EPK.Delivery.Popup.$selectTime.text('').append($('<span>').append('○')).append($(this).text());
		EPK.Delivery.Popup.selectedStartTime = $targetInputEl.data('startTime');
		EPK.Delivery.Popup.selectedEndTime = $targetInputEl.data('endTime');
		EPK.Delivery.Popup.setDeliveryUrl();
	});
}
/**
 * 宅配用の要素更新
 * @method updateEventDeliveryElements
 */
EPK.Delivery.Popup.updateEventDeliveryElements = function () {
	EPK.Delivery.Popup.$deliveryPopupCloseBtn = $('.deli-btn-box .close');
	EPK.Delivery.Popup.$deliveryPopupNextBtn = $('.deli-btn-box .agree a');
	EPK.Delivery.Popup.$ulDeliveryDaySelections = $('#ul_delivery_day_selections a');
	EPK.Delivery.Popup.$btnBackToFlow = $('.back-to-flow');
	EPK.Delivery.Popup.$btnBack = $('.dayselect-backbtn a');
	EPK.Delivery.Popup.$btnChangeDate = $('#select-day').closest('li');
	EPK.Delivery.Popup.$btnSendDeliveryForm = $('.modal-btn-send a');
	EPK.Delivery.Popup.$selectDay = $('#select-day');
	EPK.Delivery.Popup.$selectTime = $('.select-time.delivery');
	EPK.Delivery.Popup.deliveryBaseUrl = EPK.Delivery.Popup.$btnSendDeliveryForm.data('url');
};

/**
 * 時間指定モーダルのスライダー要素を削除
 * @method deleteDateTimeSlide
 */
EPK.Delivery.Popup.deleteDateTimeSlide = function () {
	EPK.Delivery.Popup.$reserveDatetimeSwiper.removeAllSlides();
}
/**
 * 日付をフォーマットする
 * @param  {Date}   date     日付
 * @param  {String} [format] フォーマット
 * @return {String}          フォーマット済み日付
 */
EPK.Delivery.Popup.formatDate = function (date, format, hidden) {
	if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
	var weekArray = ['日', '月', '火', '水', '木', '金', '土'];
	format = format.replace(/YYYY/g, date.getFullYear());
	if (hidden) {
		format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
		format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
		format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
	} else {
		format = format.replace(/MM/g, (date.getMonth() + 1));
		format = format.replace(/DD/g, (date.getDate()));
		format = format.replace(/hh/g, date.getHours());
	}
	format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
	format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
	format = format.replace(/week/g, weekArray[date.getDay()]);

	if (format.match(/S/g)) {
		var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
		var length = format.match(/S/g).length;
		for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
	}
	return format;
};

EPK.Delivery.Popup.minutesDistance = function(src, dst) {
	var SECOND_MILLISECOND = 1000,
		MINUTE_MILLISECOND = 60 * SECOND_MILLISECOND,
		HOUR_MILLISECOND = 60 * MINUTE_MILLISECOND,
		DAY_MILLISECOND = 24 * HOUR_MILLISECOND,
		WEEK_MILLISECOND = 7 * DAY_MILLISECOND,
		YEAR_MILLISECOND = 365 * DAY_MILLISECOND;

	var deltaMinutes = dst.getTime() - src.getTime();

	return deltaMinutes / MINUTE_MILLISECOND;
};

EPK.Delivery.Popup.setDeliveryUrl = function() {
	if (EPK.common.isLogin) {
		var url = EPK.Delivery.Popup.deliveryBaseUrl + '&selected_start_datetime=' + EPK.Delivery.Popup.selectedDate + EPK.Delivery.Popup.selectedStartTime + '&selected_end_datetime=' + EPK.Delivery.Popup.selectedDate + EPK.Delivery.Popup.selectedEndTime;
	} else {
		var url = EPK.Delivery.Popup.deliveryBaseUrl + encodeURIComponent('&selected_start_datetime=' + EPK.Delivery.Popup.selectedDate + EPK.Delivery.Popup.selectedStartTime + '&selected_end_datetime=' + EPK.Delivery.Popup.selectedDate + EPK.Delivery.Popup.selectedEndTime);
	}

	EPK.Delivery.Popup.$btnSendDeliveryForm.prop('href', url);
};

EPK.Delivery.Popup.initEvents = function() {
	EPK.Delivery.Popup.$deliveryBtn.on('click', function(e) {
		if ($(this).hasClass('disabled')) {
			return false;
		}
		EPK.Delivery.Popup.initPopup(0);
	});
};

EPK.Delivery.Popup.initPopup = function(popupId) {
	EPK.Delivery.Popup.open(popupId);
	EPK.Delivery.Popup.$btnSendDeliveryForm.prop('href', EPK.Delivery.Popup.deliveryBaseUrl);
};

EPK.Delivery.Popup.bindEvents = function() {
	EPK.Delivery.Popup.$deliveryPopupCloseBtn.on('click', function(e) {
		$.magnificPopup.close();
	});

	EPK.Delivery.Popup.$deliveryPopupNextBtn.on('click', function(e) {
		EPK.Delivery.Popup.initPopup(1);
	});

	EPK.Delivery.Popup.$ulDeliveryDaySelections.on('click', function(e) {
		if ($(this).hasClass('disabled')) {
			return false;
		}

		EPK.Delivery.Popup.selectedDate = $(this).data('date');
		var year = EPK.Delivery.Popup.selectedDate.toString().slice(0, 4);
		var month = EPK.Delivery.Popup.selectedDate.toString().slice(4, 6);
		var day = EPK.Delivery.Popup.selectedDate.toString().slice(-2);
		EPK.Delivery.Popup.$selectDay.find('.view-select-day').remove();
		EPK.Delivery.Popup.$selectDay.append($('<span class="view-select-day">').append(EPK.Delivery.Popup.formatDate(new Date(year, month-1, day), 'MM月DD日(week)', false)));
		EPK.Delivery.Popup.initPopup(2);
		EPK.Delivery.Popup.initPopupSwiper();
	});

	EPK.Delivery.Popup.$btnBackToFlow.on('click', function(e) {
		EPK.Delivery.Popup.initPopup(0);
	});

	EPK.Delivery.Popup.$btnBack.on('click', function(e) {
		EPK.Delivery.Popup.initPopup(1);
	});

	EPK.Delivery.Popup.$btnChangeDate.on('click', function(e) {
		EPK.Delivery.Popup.initPopup(1);
	});

	EPK.Delivery.Popup.$btnSendDeliveryForm.on('click', function(e) {
		if (EPK.Delivery.Popup.$btnSendDeliveryForm.prop('href').indexOf('selected_start_datetime') === -1
			|| EPK.Delivery.Popup.$btnSendDeliveryForm.prop('href').indexOf('selected_end_datetime') === -1
		) {
			return false;
		}
	});
};
/**
 * bindEventsで設定したイベントをオフにする
 * @method unsetBindEvents
 */
EPK.Delivery.Popup.unsetBindEvents = function() {
	EPK.Delivery.Popup.$deliveryPopupCloseBtn.off('click');
	EPK.Delivery.Popup.$deliveryPopupNextBtn.off('click');
	EPK.Delivery.Popup.$ulDeliveryDaySelections.off('click');
	EPK.Delivery.Popup.$btnBackToFlow.off('click');
	EPK.Delivery.Popup.$btnBack.off('click');
	EPK.Delivery.Popup.$btnChangeDate.off('click');
	EPK.Delivery.Popup.$btnSendDeliveryForm.off('click');
};

EPK.Parking = EPK.Parking || {};
EPK.Parking.Popup = EPK.Parking.Popup || {};

EPK.Parking.Popup.initPopupSwiper = function() {
	var swiper = $('#parking-img').swiper({
		slidesPerView: 'auto',
		centeredSlides: false,
		preloadImages: true,
		lazyLoading: true, // 左記を追加
		lazyLoadingInPrevNext: true,
	});
}

EPK.Parking.Popup.open = function () {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: '#modal-parking-reserve'},
		type: 'inline',
		modal: true
	}, 0);
};

EPK.Parking.Popup.photo = function () {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: '#modal-parking-picture'},
		type: 'inline',
		modal: true
	}, 0);
	EPK.Parking.Popup.initPopupSwiper();
};

EPK.Parking.Popup.select = function () {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: '#modal-parking-select-1'},
		type: 'inline',
		modal: true
	}, 0);
};

/**
 * 数値のカンマ編集
 */
EPK.PharmacyDetail.numSeparate = function(num) {
	num = String(num);

	var strMinus = '';
	if (num.indexOf('-') > -1) {
		strMinus = '-';
	}

	num = num.replace(/-/g, '');
	var len = num.length;

	if (len > 3) {
		// 前半を引数に再帰呼び出し + 後半3桁
		return strMinus + this.numSeparate(num.substring(0, len - 3)) + ',' + num.substring(len - 3);
	} else {
		return strMinus + num;
	}
}


/**
 * 電話帳店舗での近くの薬局を描画
 * @method renderNearShop
 */
EPK.PharmacyDetail.renderNearShop = function(){
	var shopId = EPK.PharmacyDetail.shop_id;

	// APIに渡す情報を作成
	var url = '/api/detail/near_shop/s'+shopId;

	$.ajax({
		url: url,
		type: 'POST',
		dataType: 'HTML',
	}).done(function(resultData) {
		// 近くの薬局を描画
		var nearShopListEl = document.getElementById('near_shop_list');
		if(nearShopListEl && resultData) {
			$(nearShopListEl).append(resultData);
		}
	});
};

/**
 * リクエストボタンの初期描画処理
 * @method initRenderEparkRequestBtn
 */
EPK.PharmacyDetail.initRenderEparkRequestBtn = function() {
	var loadingEl = document.getElementById('loading_st_send_reserve');
	var sendRevBtn = document.getElementById('st_send_reserve_async');
	if(loadingEl) {
		// 要素を表示
		$(loadingEl).after(sendRevBtn);
		// イベント設定
		$('#btn-submitShopLine').on('click', function() {
			EPK.PharmacyDetail.postShopLike();
		});
		// ローディング中要素を非表示
		loadingEl.style.display = 'none';

	} else if(sendRevBtn) {
		sendRevBtn.parentNode.removeChild(sendRevBtn);
	}
	// 導入店リクエストの成功モーダル後の回答するイベント設定
	var modal = document.getElementById('modal-net_request_complete');
	if(modal) {
		$('.request_enquete_submit a').click(
			function(e){
				if ($(this).hasClass('is-disabled')) {
					return false;
				}
				e.preventDefault();
				EPK.PharmacyDetail.postRequestAnswer();
				$.magnificPopup.close();
			}
		);

		if(EPK.utils.getUrlParam('requested')){
			EPK.PharmacyDetail.postShopLike();
		}
	}
};

/**
 * 導入店リクエストの成功モーダル後の回答処理
 * @method initRenderEparkRequestBtn
 */
EPK.PharmacyDetail.postRequestAnswer = function () {

	var data = {
		'member_id': EPK.common.member_id,
		'shop_id': EPK.PharmacyDetail.shop_id,
		// #15091 導入リクエスト修正
		//'answer1': document.getElementById('answer1_num_people').value,
		//'answer2': document.getElementById('answer2_reason').value,
		//'answer3': document.getElementById('answer3_introduce').value,
		'answer_1': parseInt($('input[name=request_enquete_answer_1]:checked').val()),
		'answer_2': parseInt($('input[name=request_enquete_answer_2]:checked').val()),
		'answer_3': parseInt($('input[name=request_enquete_answer_3]:checked').val()),
		'answer_4': parseInt($('input[name=request_enquete_answer_4]:checked').val()),
		'answer_5': parseInt($('input[name=request_enquete_answer_5]:checked').val()),
	};

	$.ajax({
		url: '/api/detail/request_enquete',
		type: 'POST',
		cache: false,
		dataType : "json",
		data: data
	}).done(function(data, textStatus, jqXHR){
		// 何もしない
	}).fail( function(data) {
		// 何もしない
	});
	return;
};

/**
 * 近くの病院・診療所の初期描画処理
 * @method renderNearHospital
 */
EPK.PharmacyDetail.renderNearHospital = function() {
	var nearHospitalContentEl = document.getElementById('near_hospital_async');
	if(nearHospitalContentEl) {
		var parentEl = document.getElementById('near_hospital');
		if(parentEl) {
			parentEl.appendChild(nearHospitalContentEl);
		} else {
			nearHospitalContentEl.parentNode.removeChild(nearHospitalContentEl);
		}
	}
};

/**
 * クーポン要素を画面に表示
 * @method updateCouponsDrawing
 */
EPK.PharmacyDetail.updateCouponsDrawing = function() {
	var $chirashiEl = $('#detail_chirashi');
	var $couponsEl = EPK.PharmacyRich ? $('#rich-detail-coupon') : $('#detail_coupon');
	var $couponTabEl = $('#coupon_tab_btn_async');
	var $shopInfoCouponBtn = $('#shopinfo_coupon_btn_async');
	var chirashiIcon = document.getElementById('feature-icon-body-chirashi');
	var couponIcon = document.getElementById('feature-icon-body-coupon');
	var $toriokiEl = $('#detail_torioki');

	// チラシ
	if ($chirashiEl.length) {
		if($('#index_chirashi').length) {
			$('#index_chirashi').append($chirashiEl);
		} else {
			$chirashiEl .remove();
		}
	}

	// クーポン
	if ($couponsEl.length) {
		if($('#index_coupon').length) {
			$('#index_coupon').append($couponsEl);

			if(EPK.PharmacyRich && EPK.PharmacyDetail.couponCount) {
				// クーポンアイコン
				EPK.PharmacyRich.renderRichCouponIcon();
			}
		} else {
			$couponsEl.remove();
		}
	}
	// チラシアイコン
	if(chirashiIcon) {
		if(EPK.PharmacyDetail.shufooShopChirashiListCount) {
			chirashiIcon.style.display = '';
		} else {
			chirashiIcon.parentNode.removeChild(chirashiIcon);
		}
	}

	// チラシ・クーポンタブボタン
	if ($couponTabEl.length) {
		if ($('#coupon_tab_btn').length) {
			$('#coupon_tab_btn').after($couponTabEl);
			$('#coupon_tab_btn').remove();
			if ($couponTabEl.find('.noactive').length == 0) {
				if (!EPK.PharmacyDetail.shohobin_flag) {
					var title = document.title;
					title = title.replace(/【.*】/, '');
					document.title = "【チラシあり】" + title;
				}
			}
		} else {
			$couponTabEl.remove();
		}
	}

	// 対応サービス・クーポン
	var len = $shopInfoCouponBtn.length;
	if (len) {
		if ($('#shopinfo_coupon_btn').length) {
			$('#shopinfo_coupon_btn').after($shopInfoCouponBtn);
		} else {
			$shopInfoCouponBtn.remove();
		}
	}
	$('#shopinfo_coupon_btn').remove();
	// クーポンアイコン
	if(couponIcon) {
		if (len || EPK.PharmacyDetail.couponCount) {
			// クーポンページのクーポン件数は非同期で取得できないのでjsの値から判定

			$('.st-coupon').removeClass('off');
			// 特徴のアイコン表示
			if (couponIcon) {
				couponIcon.style.display = '';
			}
		} else {
			couponIcon.parentNode.removeChild(couponIcon);
		}
	}

	// 取り置き
	if ($toriokiEl.length) {
		$($couponsEl).after($toriokiEl);
	}
};
/**
 * 本日の営業時間/調剤時間を画面に表示
 * @method updateTodayTimeDrawing
 */
EPK.PharmacyDetail.updateTodayTimeDrawing = function(){
	var salesTimeContents = $('.st_sales_time');
	if ($('.st_sales_time_async').length) {
		if (salesTimeContents.length) {
			salesTimeContents.after($('.st_sales_time_async'));
		}
	}
	salesTimeContents.remove();

	// 臨時営業・休業バルーン
	var $balloonContents = $('.s_holiday_box_detail');
	if ($('.s_holiday_box_detail_async').length) {
		if ($balloonContents.length) {
			$balloonContents.after($('.s_holiday_box_detail_async'));
		}
	}
	$balloonContents.remove();
};

/**
 * 詳細非同期取得
 * @method fetchOtherDetailInfo
 */
EPK.PharmacyDetail.fetchOtherDetailInfo = function(){
	var shopId = EPK.PharmacyDetail.shop_id;
	var $detailCouponParent = $('#index_coupon');

	// APIに渡す情報を作成
	var url = '/api/detail/other_async/s'+shopId;

	$.ajax({
		url: url,
		type: 'POST',
		dataType: 'HTML',
		data: {
			page: EPK.common.action,
			km_brand_page_id: EPK.PharmacyDetail.km_brand_page_id,
			availables: EPK.PharmacyDetail.availables || null
		}
	}).done(function(resultData) {
		// ローディングアイコン削除
		$detailCouponParent.empty();
		// コンテンツ描画
		if(resultData) {
			$('body').append(resultData);
			// クーポンを表示
			EPK.PharmacyDetail.updateCouponsDrawing();
		}
	}).fail(function(){
		console.error('fail: '+url);
		// ローディングアイコン削除
		$detailCouponParent.empty();
	}).always(function(){

		// 本日の営業時間・調剤開局時間
		EPK.PharmacyDetail.updateTodayTimeDrawing();
		// 赤枠のアラート文言表示
		EPK.PharmacyDetail.renderReceptionistWarning();
		// 近くの病院・診療所
		EPK.PharmacyDetail.renderNearHospital();
		// 導入店混雑状況
		if (EPK.common.action == 'index' && EPK.PharmacyDetail.shohobin_flag == '1' && !EPK.PharmacyRich) {
			EPK.PharmacyDetail.renderDispensingQueue();
		}

		if(!EPK.PharmacyDetail.shohobin_flag) {
			// 電話帳店舗
			EPK.PharmacyDetail.initRenderEparkRequestBtn();
		}
		// リッチ店舗
		if(EPK.PharmacyRich) {
			EPK.PharmacyRich.refreshAsyncEls();
		}
		// 宅配、駐車場のイベントを設定
		EPK.PharmacyDetail.setRevBtnEvent();
	});
};
/**
 * フロートボタンの後に実行したい非同期処理実行用
 * ※ 本来はPromiseを使用し切り離したいがIEがPromise未対応の為
 * フロートボタン非同期関数から直接呼び出す
 * @method callbackOfRenderFloatBtn
 */
EPK.PharmacyDetail.callbackOfRenderFloatBtn = function() {
	// 電話帳非同期
	if (EPK.PharmacyDetail.shohobin_flag == 0){
		EPK.PharmacyDetail.renderNearShop();
	}

	// 詳細非同期取得
	EPK.PharmacyDetail.fetchOtherDetailInfo();
};

/**
 * #12464 非リッチ混雑状況を表示
 * @method renderDispensingQueue
 */
EPK.PharmacyDetail.renderDispensingQueue = function() {
	var congestionEl = document.getElementById('reserveRight');

	if (!congestionEl) {
		return;
	}

	//混雑状況があったら中身を書き換えていく
	var shohoContents = document.querySelector('div.st-detail-main div.shoho-contents');
	var reserveBtn = document.querySelectorAll('div.shoho-contents div.shoho-btn');
	var shohoSubTitle = document.querySelector('div.shoho-contents p.shoho-subtitle');
	var contents = document.querySelector('div.shoho-contents .shoho-reserve-box');
	var createWrap = function () {
		var wrap = '<div id="reserveWrap" class="shoho-reserve-wrap">\n' +
						'<div id="reserveLeft" class="shoho-reserve-left">\n' +
							'<p id="subTitle" class="shoho-subtitle">・この店舗で処方箋受付をネットからすると…</p>\n' +
						'</div>\n' +
					'</div>';
		return wrap;
	}

	//サブタイトル削除
	if (shohoSubTitle) {
		shohoSubTitle.parentNode.removeChild(shohoSubTitle);
	}
	//コンテンツ削除
	if (contents) {
		contents.parentNode.removeChild(contents);
	}
	//ボタンの削除
	if (reserveBtn.length > 0) {
		for (var i = 0; i < reserveBtn.length; i++) {
			reserveBtn[i].parentNode.removeChild(reserveBtn[i]);
		}
	}

	//要素作成
	if (shohoContents) {
		shohoContents.insertAdjacentHTML('beforeend',createWrap());
		//内容の追加
		var leftWrap = document.getElementById('reserveLeft');
		if (leftWrap && contents) {
			leftWrap.insertAdjacentElement('beforeend',contents);
		}
		//混雑状況の追加
		if (leftWrap && congestionEl) {
			leftWrap.insertAdjacentElement('afterend',congestionEl);
		}
		//ボタンの追加
		if (congestionEl && reserveBtn.length > 0) {
			for (var i = 0; i < reserveBtn.length; i++) {
				shohoContents.insertAdjacentElement('beforeend',reserveBtn[i]);
			}
		}

		//モーダル
		var description = document.getElementById('description');
		if (description) {
			description.addEventListener('click',function (e) {
				var modalURL = e.currentTarget.getAttribute('data-modal-id');
				if (modalURL) {
					$.magnificPopup.close();
					$.magnificPopup.open({
						items: {src: '#' + modalURL},
						type: 'inline',
					}, 0);
				}
			},false);
		}
	}
};

$(function() {
	// 予約関連のボタンを描画
	EPK.PharmacyDetail.renderRsvBtn();

	$('.st-review-box .review-nice a').on('click', function() {
		var _this = this;
		EPK.PharmacyDetail.HelpfulNumberCountUp(_this);
	});

	if(EPK.PharmacyDetail.photoPage) {
		EPK.PharmacyDetail.initPhotoPage();
	}

	if(EPK.PharmacyDetail.topPictures){
		EPK.PharmacyDetail.initTopPicture();
	}

	if(EPK.PharmacyDetail.mapPage){
		EPK.PharmacyDetail.Map();
	}

	if(EPK.PharmacyDetail.mapPagePcUnderLayer){
		EPK.PharmacyDetail.MapPcUnderLayer();
	}

	if(EPK.Fdoc.needMap){
		// EPK.Fdoc.Map.init();
	}

	// 駐車場受取り
	$('.parking-reserve-btn').on('click', function() {
		EPK.Parking.Popup.open();
	});
	$('.parking-photo-btn').on('click', function() {
		EPK.Parking.Popup.photo();
	});
	$('.parking-delivery-select-btn').on('click', function() {
		EPK.Parking.Popup.select();
	});
	//薬局からのコメント
	$(".pharmacy_txt_more").click(function() {
		if ($(this).hasClass("on")) {
			$("#from_pharmacy").html($(this).attr("ellipsis-txt"));
			$(this).removeClass("on");
		} else {
			$("#from_pharmacy").html($(this).attr("full-txt"));
			$(this).addClass("on");
		}
	});
	//運営からのコメント
	$(".operator_txt_more").click(function() {
		if ($(this).hasClass("on")) {
			$("#from_operator").html($(this).attr("ellipsis-txt"));
			$(this).removeClass("on");
		} else {
			$("#from_operator").html($(this).attr("full-txt"));
			$(this).addClass("on");
		}
	});


	if(EPK.PharmacyDetail.coupon) {
		$('a.coupon-accept').on('click', function(){
			var pharmacy_id = $(this).data('pharmacy_id');
			var coupon_id = $(this).data('coupon_id');
			var coupon_name = $(this).data('coupon_name');
			var reserve_flg = $(this).data('reserve_flg');
			var detail_action = $(this).data('detail_action');
			var epark_point = $(this).data('epark_point');
			var url = '/coupon/accept/' + coupon_id + '/' + pharmacy_id;
			var coupon_csrf_token = $(this).data('coupon_csrf_token');
			var controller_name = $(this).data('controller_name');

			if(epark_point > 0){
				EPK.PharmacyDetail.OpenConfirmPopupEparkPointCoupon(coupon_name, reserve_flg, pharmacy_id, coupon_id, detail_action, coupon_csrf_token, controller_name);
			}else{
				EPK.PharmacyDetail.AcceptCoupon(url, coupon_name, reserve_flg, pharmacy_id, detail_action, coupon_csrf_token, controller_name);
			}
		});

		$('#accept-epark-point-coupon').on('click', function(){
			var $target = $('#accept-epark-point-coupon a');
			var pharmacy_id = $target.data('pharmacy_id');
			var coupon_id = $target.data('coupon_id');
			var coupon_name = $target.data('coupon_name');
			var reserve_flg = $target.data('reserve_flg');
			var detail_action = $target.data('detail_action');
			var url = '/coupon/accept/'+coupon_id+'/'+pharmacy_id;
			var coupon_csrf_token = $target.data('coupon_csrf_token');
			var controller_name = $target.data('controller_name');

			EPK.PharmacyDetail.AcceptCoupon(url, coupon_name, reserve_flg, pharmacy_id, detail_action, coupon_csrf_token, controller_name);
        });
	}

	//「スマートフォンからこの薬局情報ページにアクセス！」「スマホに送る」メール送信
	$(".mobile_email_send").click(function() {
		var index = $(this).data('mobile_email_send');

		if(!EPK.PharmacyDetail.execMobileEmailDetailInformation(index)){
			return false;
		}

		return true;
	});

	//「スマートフォンからこの薬局情報ページにアクセス！」「スマホに送る」エラー発生時の再試行
	$("#mobile_email_send_retry").click(function() {
		var index = $('#mobile_email_index').val();

		if(!EPK.PharmacyDetail.execMobileEmailDetailInformation(index)){
			return false;
		}

		return true;
	});

	// // 宅配予約ボタン
	// EPK.Delivery.Popup.bindEvents();
});

//コメント欄の高さ
$(function(){
	$('.comment').each(function(){
		var mainHeight = $(this).find('.message').height();
		var textHeight = $(this).find('.message').children('p').outerHeight();
		//console.log(mainHeight);
		//console.log(textHeight);
		if(textHeight < mainHeight){
			$(this).find('.message').addClass('is-min');
			$(this).find('.message').find('p').addClass('is-min');
			$(this).find('dd').addClass('is-padding');
		}
		if(textHeight > mainHeight){
			$(this).find('label').addClass('ellip');
			$(this).find('label').removeClass('no-ellip');
		}else {
			$(this).find('label').addClass('no-ellip');
			$(this).find('label').removeClass('ellip');
		}
	});
});

var brandCouponSlider = document.getElementById('brand-coupon-slider');
if (brandCouponSlider) {
	var brandCouponSlides = $(brandCouponSlider).find(".swiper-slide");
	if (brandCouponSlides.length > 3) {
		// PCはクーポン3枚以上でスライダー表示にする
		$(brandCouponSlider).swiper({
			slidesPerView: 3,
			spaceBetween: 11,
			loop: false,
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			pagination: '.swiper-pagination',
		});
	}
}

// 提供サービス
$(function () {
	//左右ボタン押下
	$("#services-provided").swiper({
		scrollbarHide: true,
		slidesPerView: 'auto',
		centeredSlides: false,
		spaceBetween: 15,
		grabCursor: true,
		preloadImages: true,
		nextButton: ".swiper-button-next",
		prevButton: ".swiper-button-prev",
	});

	$('#servicelist-label').swiper({
		scrollbarHide: true,
		slidesPerView: 'auto',
		centeredSlides: false,
		grabCursor: true,
		preloadImages: true,
	});

	//タブ押下
	var serviceListContainer = $('#services-provided');
	var sliderEl = serviceListContainer.find('.swiper-slide');
	if (!serviceListContainer.length) {
		return;
	}
	if (sliderEl) {
		var serviceListContainerSwiper = serviceListContainer.swiper({
			scrollbarHide: true,
			slidesPerView: 'auto',
			centeredSlides: false,
			grabCursor: true,
			preloadImages: true,
			spaceBetween: 15,
			nextButton: ".swiper-button-next",
			prevButton: ".swiper-button-prev",
		});

		var serviceListLabels = $('.servicelist-label li a');
		if (serviceListLabels.length) {
			serviceListLabels.each(function(i,e) {
				$(e).on('click', function() {
					var slideCount = $(this).data('slide_count');
					serviceListContainerSwiper.slideTo(slideCount);

					// 選択状態変更
					$('.servicelist-label li').removeClass('is-active');
					$(this).closest('li').addClass('is-active');
				});
			});
		}
	}
});

